import React, { Component } from "react";
import PropTypes from 'prop-types';
import katex from 'katex';

class Katex extends Component {
  static propTypes = {
    children: PropTypes.any,
  };

  constructor(props) {
    super(props);

    this.katexSpace = React.createRef();
  }

  componentDidMount() {
    if (this.katexSpace && this.katexSpace.current) {
      const html = katex.renderToString(this.props.children[0], { throwOnError: false, errorColor: "#cc0000", trust: false });
      this.katexSpace.current.innerHTML = html;
    }
  }

  render = () => <span {...this.props} className="codai-markdown-katex" ref={this.katexSpace}></span>;
}

export default Katex;
